<!DOCTYPE html>
<html>

  <head>
    <meta charset="UTF-8" />
  </head>
  <style scoped>

  </style>
  <body class="fx-row" style="padding: 30px 0px 0px 0px;">
    <button mat-icon-button class="close-button" [mat-dialog-close]="true">
      <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>

    <div  mat-dialog-content class="center fx-col fx-fill-size fx-flex-100">
      <div class="carousel carousel-nav fx-flex-20-in-col" id="carouselNav" style="z-index: 1000;">
        @for (image of images; track image) {
          <div class="carousel-cell" style="border: 1px solid hsl(0,100%,0%);">
            <img [src]="env.imageUrl + image.Path" alt="" srcset="" height="100%" width="100%">
          </div>
        }
      </div>
      <div class="carousel carousel-main fx-flex-80-in-col" id="carouselMain" style="z-index: 100;">
        @for (image of images; track image) {
          <div class="carousel-cell">
            <!-- <img [src]="env.imageUrl + image.Path" alt="" srcset="" height="100%" width="100%"> -->
            <lib-ngx-image-zoom  [thumbImage]="env.imageUrl + image.Path"
              [fullImage]="env.imageUrl + image.Path"
              [magnification]="1" [enableScrollZoom]="true" [enableLens]="true" [lensWidth]="250" [lensHeight]="250"
            [zoomMode]="'hover'"></lib-ngx-image-zoom>
          </div>
        }
      </div>
      @if (images.length == 0) {
        <div class="p-10 m-t-70 text-center fx-row"><p class="f-s-20 fx-flex-100"> No Images Found!!</p></div>
      }
    </div>
  </body>
  <script>
    import "./flickity.component.css";
    import "flickity/css/flickity.css";
  </script>

</html>
